import { createFileRoute } from '@tanstack/react-router'
import { AdminLogin } from '../components/auth/admin-login'

export const Route = createFileRoute('/login')({
  component: AdminLogin,
})
